import { Empty } from "antd";
import React from "react";

export const EmptyContent = ({ description }) => {
	return <Empty description={<h4>{description}</h4>}></Empty>;
};
